import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import { LinkStyled } from './styles';

export default () => (
  <InformationalModule
    // configs
    sectionId='insurance-product-intro'
    moduleName='intro-module'
    moduleVariation='A'
    disableBottomPadding={false}
    reverseContent={false}
    // content
    headingText={
      <>
        Insurance coverage that can do more <WidowBlock>for you</WidowBlock>
      </>
    }
    introContent={(
      <>
        <Typography
          align='left'
          nextElement='button'>
          At Northwestern Mutual, managing risk is a key part of our financial planning philosophy. We help people live more and worry less&#8212;today and down the road. Our advisors will help you figure out the right types of insurance, and exactly how much you need. And with the highest financial strength ratings in the industry<sup>1</sup> and over 164 years in this business, we&#39;ll be here whenever you need us.
        </Typography>
        <LinkStyled
          id='insurance-product-intro-cta-fafa'
          ariaLabel='Learn about your life insurance needs from a financial advisor'
          linkUrl='/find-a-financial-advisor/'
          variant='buttonLinkPrimary'>
          Get started
        </LinkStyled>
      </>
    )}
  />
);
